function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3991 8.4508C17.8092 9.2339 20.2187 10.8964 21.7082 12.9466C23.1977 14.9967 24 17.4658 24 20L18 20C18 18.7329 17.5989 17.4984 16.8541 16.4733C16.1093 15.4482 15.5015 14.7687 14.2965 14.3772L15.3991 8.4508Z",
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.72205e-05 20C5.7066e-05 18.2336 0.390028 16.489 1.14213 14.8906C1.89424 13.2923 2.98992 11.8798 4.35097 10.7538C5.71202 9.62789 7.30486 8.81629 9.01578 8.377C10.7267 7.93771 13.0339 7.90323 14.769 8.23422L12.6032 14.0031C11.5991 14.0031 11.3634 13.9689 10.5079 14.1885C9.65246 14.4081 8.85604 14.8139 8.17551 15.3769C7.49499 15.9399 6.94715 16.6462 6.57109 17.4453C6.19504 18.2445 6.00006 19.1168 6.00006 20L5.72205e-05 20Z",
  fill: "#F5841F"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 19,
  r: 2,
  fill: "#D9D9D9"
});

function SvgCallQualityFair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallQualityFair);
export default __webpack_public_path__ + "static/media/call_quality_fair.a7061a55.svg";
export { ForwardRef as ReactComponent };